import { createContext } from "react";

export const mobileDevice = createContext({})